import React, { type ReactNode } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { CheckSmallIcon } from '@/icons';
import { DropdownMenu, DropdownMenuContent, type DropdownMenuContentProps, DropdownMenuItem, DropdownMenuTrigger } from '@/ui';
import { cn } from '@/utils';
export const SelectedDropDownMenu = (props: {
  menu: {
    name: string;
    value: string;
  }[];
  selectedValue: string;
  onSelectedMenu: (selectedValue: string) => void;
  selectedLabel: ReactNode;
  className?: string;
  asChildTrigger?: boolean;
  contentProps: DropdownMenuContentProps;
}) => {
  return <DropdownMenu data-sentry-element="DropdownMenu" data-sentry-component="SelectedDropDownMenu" data-sentry-source-file="SelectedDropDownMenu.tsx">
      <DropdownMenuTrigger data-no-focus-visible asChild={props.asChildTrigger} className={cn('w-fit focus-visible:outline-none', '[&[data-state=open]>svg:last-of-type]:rotate-180', 'flex items-center gap-xs py-2xs px-4xs', props.className)} data-sentry-element="DropdownMenuTrigger" data-sentry-source-file="SelectedDropDownMenu.tsx">
        {props.selectedLabel}
      </DropdownMenuTrigger>
      <DropdownMenuContent align={props.contentProps.align} className={'min-w-[180px]'} data-sentry-element="DropdownMenuContent" data-sentry-source-file="SelectedDropDownMenu.tsx">
        {props.menu.map(item => {
        const selectedItem = item.value === props.selectedValue;
        return <DropdownMenuItem className={selectedItem ? ' bg-strong-alternative focus:bg-strong-alternative' : ''} key={item.value} onClick={() => {
          props.onSelectedMenu(item.value);
        }}>
              <div className={cn('flex w-full items-center justify-between gap-xs', selectedItem && 'text-strong')}>
                {item.name}
                {selectedItem && <CheckSmallIcon fill={ICON_COLOR.strong} size={'xs'} />}
              </div>
            </DropdownMenuItem>;
      })}
      </DropdownMenuContent>
    </DropdownMenu>;
};